<template>
    <div class="keyfeature-desktop-slide-item text-white">
        <div class="keyfeature-desktop-slide-inner grid items-start">
            <KeyFeatureItemsDesktop :featureItem="featureItem" v-for="(featureItem, i) in keyfeaturesDesktop.keyfeatureDesktopList" :key="i"  />
        </div>
    </div>
</template>

<script>
    import KeyFeatureItemsDesktop from "../sections/services/keyfeatures/KeyFeatureItemsDesktop";
    export default {
        name: "KeyfeatureSlider",
        props: ['keyfeaturesDesktop'],
        components: {
            KeyFeatureItemsDesktop
        }
    }
</script>

<style scoped>

</style>